interface INavbarItem {
    text: string;
    to?: string;
    className?: string;
}

function NavbarItem(props: INavbarItem) {
    return <div className={`${props.className} flex justify-center items-center`}>
        {props.to ? <a href={`#${props.to}`} className="block hover:bg-primary py-3 text-center transition">{props.text}</a> : <span>{props.text}</span>}
    </div>
}

export default NavbarItem;